import { Icon } from "../../../../components";
import sellarLogoBg from "../../../../images/sellar-logo-bg.png";
import sellarLogoNew from "../../../../images/sellar-logo-new.png";

export const PreorderMarketingCard = () => {
  const linkUrl =
    "https://intercom.help/sellario/en/articles/10214249-supplier-guide-pre-orders";
  return (
    <div
      className="flex items-center justify-between rounded-lg border border-zinc-300 bg-[length:50px_50px] bg-repeat p-3 font-sans"
      style={{
        backgroundImage: `url(${sellarLogoBg})`,
      }}
    >
      <div className="flex items-center gap-2">
        <img src={sellarLogoNew} className={"h-8 w-8 shrink-0"} />
        <div className="flex flex-col items-start justify-between gap-1">
          <span className="flex-1 font-semibold">Setting up a pre-order</span>
          <div>
            Discover the new and improved way to manage your stock in Sellar
          </div>
        </div>
      </div>
      <a
        href={linkUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex shrink-0 gap-2 text-sm font-semibold text-zinc-800"
      >
        <span className="">LEARN MORE</span>
        <Icon icon="CHEVRON_RIGHT" />
      </a>
    </div>
  );
};
